module.exports = __webpack_public_path__ + "e6852e866a3bda559e0dfa5191c6aff1.svg";